'use strict';
import Barba from 'barba.js';
import Env from '../base/env.js';
import Channels from '../base/channels'
import Mailto from '../components/Mailto'

let page

class Page
{
    constructor(view='')
    {
        this.view = view
        this.classView = 'currentView--basic'
        console.log('baller');
        // Fns
        new Mailto(this.view)
        // Launch Fn
        this.funcLaunch = this.intro.bind(this)
        if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()
    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    destroy()
    {
        Channels.removeListener('launcher::exit', this.funcLaunch);
    }

    finalize()
    {
        setTimeout(() => {
            if(Env.isVisiting === true) {
                this.intro()
            }
        }, 200);
    }

    intro()
    {
        const tl = new TimelineLite()
        const $content = this.view.querySelector('.basic')
        tl.add([
            TweenLite.fromTo($content , .8 , { autoAlpha : 0 , y : 20 } , { autoAlpha : 1, y : 0 , ease : Cubic.easeOut }),
        ])
    }
}

page = Barba.BaseView.extend({
    namespace: 'basic',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {
        this.node.finalize()
    },
    onLeave: function()
    {
        this.node.destroy()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;


// WEBPACK FOOTER //
// ./resources/js/view/basic.js